import { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BigSidebar from "./displayComponent/BigSidebar.js";
import SmallSideBar from "./displayComponent/SmallSideBar.js";
import GlobalAppContext from "../../../../globals/GlobalAppContext";
import "./sideMenu.css";
import "./sideMenuMobile.css";

const SideMenu = () => {
    // remove this once available for all
    const isAllowedToViewNewContent =
        GlobalAppContext.isAllowedToViewNewContent();

    let location = useLocation();
    let navigate = useNavigate();

    const [sideContainer, setSideContainer] = useState({ display: "block" });
    const [showSmallPanel, setShowSmallPanel] = useState(true);

    const sideContainerRef = useRef(null);
    const toggleButtonRef = useRef(null);

    // detect mobile
    let isMobileDevice = window.innerWidth <= 878;

    const menuToggle = (e) => {
        e.preventDefault();
        e.stopPropagation();
        // show the sidebar
        if (sideContainer.display === "none")
            setSideContainer({ display: "block" });

        // hide the sidebar commpletly on mobile
        if (sideContainer.display === "block" && isMobileDevice)
            setSideContainer({ display: "none" });

        if (showSmallPanel && !isMobileDevice) setShowSmallPanel(false);
        if (!showSmallPanel && !isMobileDevice) setShowSmallPanel(true);
    };

    const menuToggleOnClickMobile = (e) => {
        e.preventDefault();
        e.stopPropagation();

        // show the sidebar
        if (sideContainer.display === "none")
            setSideContainer({ display: "block" });

        // hide the sidebar commpletly on mobile
        if (sideContainer.display === "block" && isMobileDevice)
            setSideContainer({ display: "none" });
    };

    if (isMobileDevice && showSmallPanel === true) {
        setSideContainer({ display: "none" });
        setShowSmallPanel(false);
    }

    // Add and remove event listeners on mount and unmount
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (showSmallPanel) return;

            // Check if the required refs are available
            if (sideContainerRef.current && toggleButtonRef.current) {
                // Check if the click happened inside the sidebar, toggle button, or small toggle button (if it exists)
                const isClickInsideSidebar = sideContainerRef.current.contains(
                    e.target,
                );
                const isClickInsideToggleButton =
                    toggleButtonRef.current.contains(e.target);

                // If the click is outside all the elements (sidebar, toggle button, and small toggle button)
                if (!isClickInsideSidebar && !isClickInsideToggleButton) {
                    // Handle logic for outside click (e.g., close sidebar or hide panel)
                    setShowSmallPanel(true);
                }
            }
        };

        // Add the event listener
        document.addEventListener("click", handleClickOutside);

        // Clean up the event listener on unmount
        return () => document.removeEventListener("click", handleClickOutside);
    }, [showSmallPanel]);

    useEffect(() => {
        // this allowes the sidebar to adjust on resizing
        function handleResize() {
            if (window.innerWidth <= 878) {
                setSideContainer({ display: "none" });
                setShowSmallPanel(false);
            }

            if (window.innerWidth >= 878) {
                setSideContainer({ display: "block" });
                setShowSmallPanel(true);
            }
        }

        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    });

    // big sideBar
    let displayCompontent = (
        <BigSidebar
            sideContainerRef={sideContainerRef}
            menuToggle={menuToggle}
            sideContainer={sideContainer}
            menuToggleOnClickMobile={menuToggleOnClickMobile}
            navigate={navigate}
            location={location}
            isAllowedToViewNewContent={isAllowedToViewNewContent}
            toggleButtonRef={toggleButtonRef}
            setShowSmallPanel={setShowSmallPanel}
        />
    );

    if (showSmallPanel && !isMobileDevice) {
        displayCompontent = (
            <SmallSideBar
                menuToggle={menuToggle}
                sideContainer={sideContainer}
                menuToggleOnClickMobile={menuToggleOnClickMobile}
                navigate={navigate}
                location={location}
                isAllowedToViewNewContent={isAllowedToViewNewContent}
            />
        );
    }

    return displayCompontent;
};

export default SideMenu;
